import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { money } from "../lib/format";

export default function WalletCard({ meta, data, currency, onManage, index = 0 }) {
  const planned = data?.planned || 0;
  const actual = data?.actual || 0;
  const variance = data?.variance || 0;
  const pct = Math.min(Math.max(data?.pct || 0, 0), 100);
  const Icon = meta.icon;
  const over = meta.key === "bills" || meta.key === "unplanned" ? actual > planned : false;
  const negative = data?.actual < 0;

  return (
    <motion.button
      data-testid={`wallet-card-${meta.testKey}`}
      onClick={onManage}
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.06 }}
      whileHover={{ y: -3 }}
      className="text-left bg-white rounded-2xl border border-slate-200 p-5 shadow-sm hover:shadow-md hover:border-slate-300 transition-all group"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: meta.bg, color: meta.icon_color }}>
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <p className="font-display font-semibold text-slate-900 text-[15px] leading-tight">{meta.title}</p>
            <span className="text-[11px] font-medium uppercase tracking-wider text-slate-400">{meta.badge}</span>
          </div>
        </div>
        <ArrowUpRight className="w-4 h-4 text-slate-300 group-hover:text-orange-500 transition-colors" />
      </div>

      <div className="mt-4">
        <p className="text-[11px] font-medium uppercase tracking-wider text-slate-400">Actual</p>
        <p className={`font-mono-nums text-2xl font-bold tracking-tight ${negative ? "text-red-600" : "text-slate-900"}`}>
          {money(actual, currency)}
        </p>
        <p className="text-xs text-slate-400 font-mono-nums">of {money(planned, currency)} planned</p>
      </div>

      {meta.key !== "my_wallet" && (
        <div className="mt-4">
          <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
            <div className="wallet-progress h-full rounded-full" style={{ width: `${pct}%`, background: over ? "#EF4444" : meta.color }} />
          </div>
          <div className="flex items-center justify-between mt-2">
            <span className="text-xs text-slate-400">{pct}% used</span>
            <span className={`text-xs font-semibold font-mono-nums ${variance >= 0 && (meta.key === "savings" || meta.key === "emergency") ? "text-emerald-600" : variance > 0 ? "text-red-500" : "text-emerald-600"}`}>
              {variance >= 0 ? "+" : ""}{money(variance, currency)}
            </span>
          </div>
        </div>
      )}

      {meta.key === "my_wallet" && (
        <div className="mt-4 flex items-center justify-between text-xs">
          <span className="text-slate-400">Carryover</span>
          <span className="font-mono-nums font-semibold text-slate-600">{money(data?.carryover || 0, currency)}</span>
        </div>
      )}
    </motion.button>
  );
}
